import { DotOutline, FunnelSimple } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuCheckbox,
  DropdownMenuContent,
  DropdownMenuCount,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import { CAMPAIGN_STATES } from "common/constants";
import { typedObjectEntries } from "common/helpers/utils";
import type { Campaign, CampaignState } from "common/types";

interface StateFilterProps {
  selectedFilters: CampaignState[];
  setFilters: (filter: CampaignState[]) => void;
  campaigns: Campaign[];
}

export default function StateFilter({
  campaigns,
  setFilters,
  selectedFilters,
}: StateFilterProps) {
  const filtersCount = selectedFilters.length;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="lg:w-44">
        <FilterButton leftIcon={<FunnelSimple />}>
          {filtersCount
            ? `${filtersCount} ${filtersCount === 1 ? "status" : "statuses"}`
            : "All statuses"}
        </FilterButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="z-aboveDialog" align="end">
        <DropdownMenuList>
          <DropdownMenuItem onClick={() => setFilters([])}>
            All statuses
            <DropdownMenuCount>
              {campaigns ? campaigns.length : 0}
            </DropdownMenuCount>
          </DropdownMenuItem>

          {typedObjectEntries(CAMPAIGN_STATES).map(
            ([key, { label, iconColor }]) => {
              const isSelected = selectedFilters.includes(key);

              return (
                <DropdownMenuItem
                  key={key}
                  onSelect={() => {
                    setFilters([key]);
                  }}
                >
                  <DropdownMenuCheckbox
                    isChecked={isSelected}
                    onCheckedChange={() => {
                      if (isSelected) {
                        setFilters(
                          selectedFilters.filter((filter) => filter !== key),
                        );
                      } else {
                        setFilters([...selectedFilters, key]);
                      }
                    }}
                  />
                  <DotOutline size={20} weight="fill" className={iconColor} />
                  {label}
                  <DropdownMenuCount>
                    {campaigns
                      ? campaigns.filter(({ state }) => state === key).length
                      : 0}
                  </DropdownMenuCount>
                </DropdownMenuItem>
              );
            },
          )}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
